export default function ValidatePhone(Phone) {
  var valid = true;
  var revPhone = Phone.siblings("[id$='revPhone']");
  var rfvPhone = Phone.siblings("[id$='rfvPhone']");
  Phone.removeClass("error");

  revPhone.hide();
  rfvPhone.hide();
  if (revPhone.hasClass("novalidate")) {
    return valid;
  }
  if (Phone.val().length == 0) {
    valid = false;
    rfvPhone.show();
    Phone.addClass("error");
  }
  else {
    var regExpPhone = /^(?:\+\d{1,3}|0\d{1,3}|00\d{1,2})?(?:\s?\(\d+\))?(?:[-\/\s.]|\d)+$/;
    if (!regExpPhone.test(Phone.val())) {
      valid = false;
      revPhone.show();
      Phone.addClass("error");
    }
  }
  return valid;
}